
// new code with only email validation

import React, { useState,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
 const [isLoading, setIsLoading] = useState(true); // State to handle loading
  const navigate = useNavigate();
useEffect(() => {
    // Simulate page initialization loading delay
    const timer = setTimeout(() => {
      setIsLoading(false); // Stop loading after 2 seconds
    }, 2000);

    return () => clearTimeout(timer); // Cleanup timeout
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
//      const response = await fetch('http://localhost:3001/auth/login', {

        const response = await fetch('/api/login', {
  
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
setIsLoading(false); 
      if (data.success) {
        // Save username in localStorage or pass it as state
        localStorage.setItem('username', data.username);
        localStorage.setItem('email', data.email);
        
        navigate('/surveyform');
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError('An error occurred. Please try again.');    }
  };

if (isLoading) {
    // Show loading spinner while page is loading
    return (
      <div className="loading-overlay">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }
  return (
    <div className="login-page">

      <div className="form-container">
      <img src="./Unext_Logo(Black).png" alt="Logo" className="logo" />
        <h2>Welcome</h2>
        {error && <p className="error">{error}</p>}
        <form onSubmit={handleLogin}>
          <label>   </label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button type="submit" className="submit-button">Login</button>
        </form>
      </div>

{/* Footer Section */}
      <footer className="footer">
        <p>© {new Date().getFullYear()} UNext Learning Pvt Ltd</p>
      </footer>
    </div>
  );
};

export default LoginPage;

